import { useState, useEffect } from 'react'
import { useParams, Link } from 'react-router-dom'
import { apiFetch } from '../lib/api'

interface Worker {
  id: string
  email: string
  name: string
  trade: string
  subscription_tier: string
  subscription_status: string
  cscs_status: string
  verified: number
  created_at: string
}

interface Verification {
  status: string
  confidence: number
  result: any
  created_at: string
  reviewed_at: string
}

export function WorkerDetail() {
  const { id } = useParams<{ id: string }>()
  const [worker, setWorker] = useState<Worker | null>(null)
  const [verification, setVerification] = useState<Verification | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (id) fetchWorker(id)
  }, [id])

  async function fetchWorker(workerId: string) {
    try {
      const data = await apiFetch(`/api/admin/workers/${workerId}`)
      setWorker(data.worker)
      setVerification(data.verification)
    } catch {}
    setLoading(false)
  }

  if (loading) return <div className="loading">Loading worker...</div>
  if (!worker) return <div className="loading">Worker not found</div>

  return (
    <div className="page">
      <header className="page-header">
        <Link to="/workers" className="back-link">← Back to Workers</Link>
        <h1>{worker.name || 'Unnamed Worker'}</h1>
        <p>{worker.email}</p>
      </header>

      <div className="detail-grid">
        <div className="detail-card">
          <h3>Profile</h3>
          <div className="field">
            <label>Trade</label>
            <p>{worker.trade || 'Not set'}</p>
          </div>
          <div className="field">
            <label>Subscription</label>
            <p className="badge">{worker.subscription_tier}</p>
          </div>
          <div className="field">
            <label>Status</label>
            <p>{worker.subscription_status}</p>
          </div>
          <div className="field">
            <label>Joined</label>
            <p>{new Date(worker.created_at).toLocaleDateString()}</p>
          </div>
        </div>

        <div className="detail-card">
          <h3>CSCS Verification</h3>
          <div className="field">
            <label>Status</label>
            <p className={`status-badge ${worker.cscs_status}`}>
              {worker.cscs_status === 'approved' ? '✓ Verified' :
               worker.cscs_status === 'pending' ? '⏳ Under review' :
               worker.cscs_status === 'rejected' ? '✗ Rejected' :
               'Not uploaded'}
            </p>
          </div>
          {verification && (
            <>
              <div className="field">
                <label>AI Confidence</label>
                <p>{verification.confidence ? `${(verification.confidence * 100).toFixed(0)}%` : 'N/A'}</p>
              </div>
              <div className="field">
                <label>Submitted</label>
                <p>{verification.created_at ? new Date(verification.created_at).toLocaleDateString() : 'N/A'}</p>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
